import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ExitIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M22.22 17.5a1.1 1.1 0 0 0-1.17 1c-.1 1.14-.22 2.13-.33 2.65a4.82 4.82 0 0 1-3.76 3.6 62.06 62.06 0 0 0-.2-11.86c-.34-2.51-1.89-5.3-3.6-6.49a19.45 19.45 0 0 0-4.51-2.26c1.26-.2 2.55-.3 3.83-.29 1.75 0 3.35.16 4.88.48a4.82 4.82 0 0 1 3.36 3.52c.1.52.23 1.51.33 2.65a1.1 1.1 0 1 0 2.17-.19c-.1-1.23-.23-2.28-.35-2.88a6.99 6.99 0 0 0-5.05-5.23h-.01a26.21 26.21 0 0 0-5.33-.53c-1.9 0-3.64.17-5.33.52h-.01a6.58 6.58 0 0 0-3.55 2.23 6.66 6.66 0 0 0-1.5 3 46.05 46.05 0 0 0-.35 11.27c.06.9.13 1.67.2 2.17.34 2.51 1.89 5.3 3.6 6.48v.01c1.2.8 2.47 1.47 3.81 2 1.35.52 2.6.84 3.8.97 1.62.15 3.1-1.26 3.54-3.3.37-.07.75-.13 1.12-.21h.01a6.99 6.99 0 0 0 5.04-5.23c.13-.61.25-1.66.36-2.9a1.1 1.1 0 0 0-1-1.18Z"
      />
      <path
        fill="currentColor"
        d="M31 14.5v-.11l-.02-.1v-.02c-.04-.2-.15-.4-.3-.54l-3.9-3.92a1.1 1.1 0 0 0-1.55 1.55l2.05 2.05h-7.55a1.1 1.1 0 1 0 0 2.18h7.54l-2.05 2.05a1.1 1.1 0 0 0 1.54 1.55l3.9-3.9a1.08 1.08 0 0 0 .32-.6l.01-.08v-.11H31Z"
      />
    </BaseIcon>
  );
}
